var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3211 1.57585C11.0868 1.34154 10.7069 1.34154 10.4726 1.57585L6.47261 5.57585C6.2383 5.81017 6.2383 6.19007 6.47261 6.42438C6.70693 6.65869 7.08682 6.65869 7.32114 6.42438L10.2969 3.44864V12.6666C10.2969 12.998 10.5655 13.2666 10.8969 13.2666C11.2282 13.2666 11.4969 12.998 11.4969 12.6666V3.44864L14.4726 6.42438C14.7069 6.65869 15.0868 6.65869 15.3211 6.42438C15.5555 6.19007 15.5555 5.81017 15.3211 5.57585L11.3211 1.57585ZM4.23014 13.3333C4.59833 13.3333 4.89681 13.6318 4.89681 14V16C4.89681 16.7385 5.49101 17.3333 6.22527 17.3333H15.565C16.3007 17.3333 16.8968 16.737 16.8968 16V14C16.8968 13.6318 17.1953 13.3333 17.5635 13.3333C17.9317 13.3333 18.2301 13.6318 18.2301 14V16C18.2301 17.4721 17.0384 18.6666 15.565 18.6666H6.22527C4.7504 18.6666 3.56348 17.4706 3.56348 16V14C3.56348 13.6318 3.86195 13.3333 4.23014 13.3333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.06d18b17d4fa32a2b446b68293b8a2c9.svg";
export { ForwardRef as ReactComponent };